<div *ngIf="!busy && !connected">

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Company ID:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="companyID"/>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Client ID:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="clientID"/>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Client Secret:
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <input type="text" pInputText [(ngModel)]="clientSecret"/>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8">
      <button type="button" (click)="SaveSettings()" class="btn btn-primary"
              [disabled]="companyID.length === 0 && clientID.length === 0">Connect to Netsuite
      </button>
    </div>
  </div>

</div>

<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-netsuite-defaults [partner]="partner"></app-netsuite-defaults>
  <!--  todo (dcorbett) removed (status)="configurationUpdate($event)"-->
</div>

